// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"ProfileMenu_menuPaper__2hjF6","menuList":"ProfileMenu_menuList__Rqg69","menuItem":"ProfileMenu_menuItem__Ay4ZL"};